import React from 'react';
import styled from '@emotion/styled';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

import { containerStyles } from '../../styles/layout';
import { rem } from '../../utilities/style';
import { media } from '../../theme/media';
import { colors } from '../../theme/colors';

import OffsetCard from '../OffsetCard';

const Container = styled.div`
  background-color: ${({ backgroundColor }) => (backgroundColor === 'Blue' ? colors.blue['50'] : colors.white)};
  padding: ${rem(32)} 0;

  ${media('>tiny')} {
    padding: ${rem(40)} 0;
  }
`;

const ContentWrapper = styled.div`
  ${containerStyles.regular}
`;

const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: ${rem(16)};

  ${media('>small')} {
    gap: ${rem(24)};
  }

  ${media('>smedium')} {
    gap: ${rem(32)};
    grid-template-columns: ${rem(412)} 1fr ${rem(412)};
  }
`;

const OffsetCards = ({ backgroundColor, offsetCards }) => (
  <Container backgroundColor={backgroundColor}>
    <ContentWrapper>
      <Cards>
        {offsetCards && offsetCards.map((card, index) => (
          <OffsetCard
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            backgroundImage={card.backgroundImage}
            badgeText={card.badgeText}
            headline={card.headline}
            subhead={card.subhead}
            text={card.text}
            primaryCtaText={card.primaryCtaText}
            primaryCtaLink={card.primaryCtaLink}
            secondaryCtaText={card.secondaryCtaText}
            secondaryCtaLink={card.secondaryCtaLink}
          />
        ))}
      </Cards>
    </ContentWrapper>
  </Container>
);

OffsetCards.propTypes = {
  offsetCards: PropTypes.arrayOf(
    PropTypes.shape(OffsetCard.propTypes)
  ),
  backgroundColor: PropTypes.oneOf(['Blue', 'White'])
};

export const query = graphql`
  fragment OffsetCardsFragment on ContentfulOffsetCards {
    __typename
    backgroundColor
    offsetCards {
      ...OffsetCardFragment
    }
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default OffsetCards;
